module.exports = __webpack_public_path__ + "media/images/iconSocialX__errorRed-2743d81aa4cae7a3f1ad98fb8d909b5f.png";